import {useEffect} from 'react';
import {useDebounce} from '~/hooks';

declare global {
  interface Window {
    jdgmCacheServer: {
      reloadAll(): void;
    };
    jdgm: {$: unknown};
    jdgm_preloader(): void;
  }
}

const MemorizedJudgeMePreloader = function Preloader() {
  const loader = useDebounce(async () => {
    const {jdgm_preloader, jdgmCacheServer, jdgm} = window;
    jdgm_preloader();
    if (jdgmCacheServer && jdgm.$) {
      jdgmCacheServer.reloadAll();
    } else if (jdgm) {
      jdgm_preloader();
      try {
        jdgmCacheServer.reloadAll();
      } catch (e) {
        console.log(e);
      }
    }
  }, 500);

  useEffect(() => {
    loader(undefined);
  });

  return null;
};

export default MemorizedJudgeMePreloader;
